/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          consumptionCategory: {
            type: 'string',
            enum: ['COOLING', 'ELECTRICITY', 'HEATING', 'STEAM'],
          },
          energySources: {
            type: 'string',
            enum: [
              'CHILLED_WATER',
              'COAL',
              'DIESEL',
              'EXHAUST_HEAT',
              'FUEL_OIL',
              'GEOTHERMAL',
              'HYDRO',
              'LIQUEFIED_PETROLEUM_GAS',
              'NATURAL_GAS',
              'NUCLEAR',
              'PETROL',
              'PRIMARY_BIOMASS',
              'SECONDARY_BIOMASS',
              'SOLAR_PHOTOVOLTAIC',
              'TIDAL',
              'UNKNOWN',
              'WIND',
              'OTHER_RENEWABLE',
            ],
          },
          unit: {
            type: 'string',
            enum: ['CUBIC_METRE', 'LITRE', 'KILOWATT_HOUR'],
          },
          totalAnnualConsumption: {
            type: 'number',
          },
          year: {
            type: 'number',
            minimum: 1000,
            maximum: 9000,
          },
        },
        required: ['consumptionCategory', 'energySources', 'year', 'unit', 'totalAnnualConsumption'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    energy_sources_pefcr: valueSchema,
  },
}
